import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./Pressure.module.css";

export function Pressure() {
  const { pressure } = useMaestriaContent();

  return (
    <section
      id="pressao"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="pressure-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <h2 id="pressure-title" className={styles.title}>
          {pressure.title}
          <strong>{pressure.titleAccent}</strong>
        </h2>
        <div className={styles.body}>
          {pressure.paragraphs.map((text) => (
            <p key={text}>{text}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
